// constants
import * as ColumnWidths from 'shared/../constants/columnWidths';

const LocationsColumns = () => [
  { Header: 'Name', accessor: 'name' },
  { Header: 'Alias', accessor: 'alias' },
  { Header: 'Type', accessor: 'typeText' },
  { Header: 'Address', accessor: 'address1' },
  { Header: 'City', accessor: 'city' },
  { Header: 'State', accessor: 'stateCode', isCentered: true, width: ColumnWidths.CITY_STATE },
  { Header: 'Postal Code', accessor: 'postalCode', isCentered: true, width: ColumnWidths.POSTAL_CODE }
];

export default LocationsColumns;
